/**
 * Allows to distribute the Omit across a union
 * https://davidgomes.com/pick-omit-over-union-types-in-typescript/
 * */

/**
 * Get the keys of T without any keys of U.
 */

/**
 * Restrict using either exclusively the keys of T or exclusively the keys of U.
 *
 * No unique keys of T can be used simultaneously with any unique keys of U.
 *
 * Example:
 * `const myVar: XOR<T, U>`
 *
 * More: https://github.com/maninak/ts-xor/tree/master#description
 */
// eslint-disable-next-line @typescript-eslint/ban-types

// eslint-disable-next-line no-shadow
export var KeyboardEventKeys = /*#__PURE__*/function (KeyboardEventKeys) {
  KeyboardEventKeys["TAB"] = "Tab";
  KeyboardEventKeys["ENTER"] = "Enter";
  KeyboardEventKeys["ESC"] = "Escape";
  KeyboardEventKeys["SPACE"] = " ";
  KeyboardEventKeys["ARROW_RIGHT"] = "ArrowRight";
  KeyboardEventKeys["ARROW_LEFT"] = "ArrowLeft";
  KeyboardEventKeys["ARROW_DOWN"] = "ArrowDown";
  KeyboardEventKeys["ARROW_UP"] = "ArrowUp";
  return KeyboardEventKeys;
}({});